import { Reducer } from 'react';
import { generateID } from '../../util/util';
import { BillboardAction, BillboardMessage } from '../actions/billboard';

export type BillboardState = {
    messages: BillboardMessage[]
};

const initialState:BillboardState = {
    messages: []
};

const billboardReducer:Reducer<BillboardState, BillboardAction> = (state = initialState, action:BillboardAction) => {
    switch(action.type){
        case "billboard.publish": 
            return {
                ...state,
                messages: state.messages.concat([{type:"info", ...action.payload, id: generateID(15)}])
            }
        case "billboard.dismiss":
            return {
                ...state,
                messages: state.messages.filter(({id}) => id !== action.payload)
            };
        case "billboard.hide":
            return {
                ...state,
                messages: state.messages.map((message) => {
                    if(message.id === action.payload){
                        message.hidden = true;
                    }
                    return {...message};
                })
            };
        default:
            return state;
    }
}

export default billboardReducer;